import { BASEURI, headers } from "../../utils/helper"
import { asyncThunkWrapper } from "../thunkHandler"
import { createAsyncThunk } from "@reduxjs/toolkit"

// Handle get all specializations
export const getAllSpecializationsReq = createAsyncThunk(
  "retrieveAll",
  async (data, thunkAPI) => {
    const params = {
      limit: data?.limit || null,
      search: data?.search || null,
      currentPage: data?.currentPage || null,
    }

    return asyncThunkWrapper(
      {
        params,
        method: "GET",
        url: `${BASEURI}/guest/specializations`,
      },
      thunkAPI,
      { toast: false }
    )
  }
)

// Handle get all specializations
export const getAllSpecializationAreasReq = createAsyncThunk(
  "retrieveAll",
  async (data, thunkAPI) => {
    const params = {
      limit: data?.limit || null,
      search: data?.search || null,
      currentPage: data?.currentPage || null,
    }

    return asyncThunkWrapper(
      {
        params,
        method: "GET",
        url: `${BASEURI}/guest/specializations-areas/${data?.id}`,
      },
      thunkAPI,
      { toast: false }
    )
  }
)

// Handle create comment
export const createComment = createAsyncThunk(
  "retrieveAll",
  async (data, thunkAPI) => {

    return asyncThunkWrapper(
      {
        data,
        method: "POST",
        headers: headers(),
        url: `${BASEURI}/user/comment/create`,
      },
      thunkAPI
    )
  }
)

// Handle create comment
export const updateComment = createAsyncThunk(
  "update",
  async (data, thunkAPI) => {

    return asyncThunkWrapper(
      {
        method: "POST",
        headers: headers(),
        data: data?.formData || {},
        url: `${BASEURI}/user/comment/update/${data?.id}`,
      },
      thunkAPI
    )
  }
)

// Handle delete comment
export const handleDeleteComment = createAsyncThunk(
  "delete",
  async (id, thunkAPI) => {

    return asyncThunkWrapper(
      {
        method: "DELETE",
        headers: headers(),
        url: `${BASEURI}/user/comment/delete/${id}`,
      },
      thunkAPI
    )
  }
)

// Handle create comment
export const addCommentReaction = createAsyncThunk(
  "create",
  async (data, thunkAPI) => {

    return asyncThunkWrapper(
      {
        method: "POST",
        headers: headers(),
        data: data?.formData || {},
        url: `${BASEURI}/user/comment/react/${data?.id}`,
      },
      thunkAPI
    )
  }
)

// Handle retrieve all draft
export const handleRetrieveAllDraft = createAsyncThunk(
  "retrieveAll",
  async (data, thunkAPI) => {
    const params = {
      limit: data?.limit || null,
      search: data?.search || null,
      currentPage: data?.currentPage || null,
    }

    return asyncThunkWrapper(
      {
        params,
        method: "GET",
        headers: headers(),
        data: data?.formData || {},
        url: `${BASEURI}/user/draft`,
      },
      thunkAPI,
      { toast: false }
    )
  }
)

// Handle report content
export const handleReportConetnt = createAsyncThunk(
  "create",
  async (data, thunkAPI) => {

    return asyncThunkWrapper(
      {
        data,
        method: "POST",
        headers: headers(),
        url: `${BASEURI}/user/content/report`,
      },
      thunkAPI,
      { toast: false }
    )
  }
)

// Handle retrieve blogs (User added comments)
export const handleRetrieveBlogs = createAsyncThunk(
  "retrieveAll",
  async (data, thunkAPI) => {
    const params = {
      limit: data?.limit || null,
      currentPage: data?.currentPage || null,
    }

    return asyncThunkWrapper(
      {
        params,
        method: "GET",
        headers: headers(),
        url: `${BASEURI}/user/comment/blog/retrieve-all`,
      },
      thunkAPI,
      { toast: false }
    )
  }
)

// Handle retrieve comments (By user)
export const handleRetrieveBlogComments = createAsyncThunk(
  "retrieveSingle",
  async (data, thunkAPI) => {
    const params = {
      limit: data?.limit || null,
      currentPage: data?.currentPage || null,
    }

    return asyncThunkWrapper(
      {
        params,
        method: "GET",
        headers: headers(),
        url: `${BASEURI}/user/comment/blog/retrieve/${data?.id}`,
      },
      thunkAPI,
      { toast: false }
    )
  }
)

//global search
export const globalSearchReq = createAsyncThunk(
  "retrieveAll",
  async (data, thunkAPI) => {
    const params = {
            type: data?.type || null,

      search: data?.search || "",
      currentPage: data?.currentPage || 1,
      limit: data?.limit || 10,
    };

    return asyncThunkWrapper(
      {
        method: "GET",
        url: `${BASEURI}/guest/global/search`,
        params,
      },
      thunkAPI,
      { toast: false }
    );
  }
);

export const fetchExchangeRate = createAsyncThunk(
  "exchangeRate/fetch",
  async (_, thunkAPI) => {
    return asyncThunkWrapper(
      {
        method: "GET",
        url: `${BASEURI}/guest/exchange-rate`,
      },
      thunkAPI,
      { toast: false }
    );
  }
);